export const FEEDBACK_EMAIL = 'dfds-support@doka.com'
export const FEEDBACK_EMAIL_INTERNAL = 'helpdesk@doka.com'
export const CONTACT_EMAIL = 'dfds-support@doka.com'
